<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="动态图片" :label-width="formLabelWidth" prop="photo">
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="editForm.photo" :src="editForm.photo" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="动态正文"
        :label-width="formLabelWidth"
        prop="contents"
      >
        <el-input
          v-model="editForm.contents"
          type="textarea"
          :rows="4"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="动态备注"
        :label-width="formLabelWidth"
        prop="remark"
      >
        <el-input
          v-model="editForm.remark"
          type="textarea"
          :rows="2"
          auto-complete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import {
  liveUpload,
  editAdvanceContent,
  addAdvanceContent,
} from '@/api/live.js';

export default {
  data() {
    return {
      liveAdvanceNoticeId: '',
      liveAdvanceContentId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      actionUrl: '',
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
    };
  },
  inject: ['reload'],
  mounted() {},
  methods: {
    resetFrom() {
      this.editForm = {};
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M; */
      return isJPG;
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        liveUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.$set(_this.editForm, 'photo', res.data.absoluteFileUrl);
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },

    async submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');

          this.editForm.liveAdvanceNoticeId = this.liveAdvanceNoticeId;

          if (this.liveAdvanceContentId != '') {
            await editAdvanceContent(this.liveAdvanceContentId, {
              ...this.editForm,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
              } else {
                this.$message.success('编辑失败!');
                return;
              }
            });
          } else {
            await addAdvanceContent({ ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('添加成功!');
              } else {
                this.$message.success('添加失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
